// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "spa-assets/on-demand/merrilledge-power-footer-module-styles") return "spa-assets/on-demand/merrilledge-power-footer-module-styles-a20f5d29a2f54e732bb1.m.js";
	if (chunkId === "spa-assets/js/vendors/vue-router") return "spa-assets/js/vendors/vue-router-f9cd5da9d12f3d8f0529.m.js";
	if (chunkId === "spa-assets/js/jcrs/site-merrilledge-outage-module-specific-power-footer-module-power-footer.json") return "spa-assets/js/jcrs/site-merrilledge-outage-module-specific-power-footer-module-power-footer-jcr-75f2ada132e3b4ac8173.m.js";
	// return url for filenames based on template
	return undefined;
};